import RoundLoader from '@shared/ui/round-loader/ui/RoundLoader';
import styles from '@features/b2b-contact-form/styles/Button.module.css';
import React from 'react';

import { useTranslation } from 'react-i18next';

interface Props {
  loading?: boolean;
  disabled?: boolean;
}

export const Button: React.FC<Props> = ({ loading = false, disabled = false }) => {
  const { t } = useTranslation();

  let buttonStyle = styles.b2bButton;
  if (loading) {
    buttonStyle += ` ${styles.b2bButtonLoading}`;
  }
  if (disabled) {
    buttonStyle += ` ${styles.b2bButtonDisabled}`;
  }

  return (
    <button className={buttonStyle} disabled={!!disabled}>
      {!loading ? t('submit') : <RoundLoader />}
    </button>
  );
};
